import { LocationScope } from '@/core/customer-success/customer-success.persistence';

export const scopeOptions: { value: LocationScope; label: string }[] = [
  { value: LocationScope.METRO, label: 'Metro area' },
  { value: LocationScope.STATE, label: 'Statewide' },
  { value: LocationScope.NATION, label: 'Nationwide' },
];

export const US_STATES = [
  { id: 'AL', title: 'Alabama' },
  { id: 'AK', title: 'Alaska' },
  { id: 'AZ', title: 'Arizona' },
  { id: 'AR', title: 'Arkansas' },
  { id: 'CA', title: 'California' },
  { id: 'CO', title: 'Colorado' },
  { id: 'CT', title: 'Connecticut' },
  { id: 'DE', title: 'Delaware' },
  { id: 'FL', title: 'Florida' },
  { id: 'GA', title: 'Georgia' },
  { id: 'HI', title: 'Hawaii' },
  { id: 'ID', title: 'Idaho' },
  { id: 'IL', title: 'Illinois' },
  { id: 'IN', title: 'Indiana' },
  { id: 'IA', title: 'Iowa' },
  { id: 'KS', title: 'Kansas' },
  { id: 'KY', title: 'Kentucky' },
  { id: 'LA', title: 'Louisiana' },
  { id: 'ME', title: 'Maine' },
  { id: 'MD', title: 'Maryland' },
  { id: 'MA', title: 'Massachusetts' },
  { id: 'MI', title: 'Michigan' },
  { id: 'MN', title: 'Minnesota' },
  { id: 'MS', title: 'Mississippi' },
  { id: 'MO', title: 'Missouri' },
  { id: 'MT', title: 'Montana' },
  { id: 'NE', title: 'Nebraska' },
  { id: 'NV', title: 'Nevada' },
  { id: 'NH', title: 'New Hampshire' },
  { id: 'NJ', title: 'New Jersey' },
  { id: 'NM', title: 'New Mexico' },
  { id: 'NY', title: 'New York' },
  { id: 'NC', title: 'North Carolina' },
  { id: 'ND', title: 'North Dakota' },
  { id: 'OH', title: 'Ohio' },
  { id: 'OK', title: 'Oklahoma' },
  { id: 'OR', title: 'Oregon' },
  { id: 'PA', title: 'Pennsylvania' },
  { id: 'RI', title: 'Rhode Island' },
  { id: 'SC', title: 'South Carolina' },
  { id: 'SD', title: 'South Dakota' },
  { id: 'TN', title: 'Tennessee' },
  { id: 'TX', title: 'Texas' },
  { id: 'UT', title: 'Utah' },
  { id: 'VT', title: 'Vermont' },
  { id: 'VA', title: 'Virginia' },
  { id: 'WA', title: 'Washington' },
  { id: 'WV', title: 'West Virginia' },
  { id: 'WI', title: 'Wisconsin' },
  { id: 'WY', title: 'Wyoming' },
];

export const MarketingReportType = {
  STANDARD: 'STANDARD',
  RELOCATION: 'RELOCATION',
  JOB_MATCH: 'JOB_MATCH',
} as const;

export type MarketingReportType = (typeof MarketingReportType)[keyof typeof MarketingReportType];

export const reportTypeItems: { id: MarketingReportType; title: string; description: string }[] = [
  {
    id: MarketingReportType.STANDARD,
    title: 'Talent Landscape',
    description: 'Understand available talent and market conditions for a role in a location.',
  },
  {
    id: MarketingReportType.RELOCATION,
    title: 'Relocation Strategy',
    description: 'Find markets where this role is easier to hire and candidates may relocate from.',
  },
  {
    id: MarketingReportType.JOB_MATCH,
    title: 'Job Match Report',
    description: 'Find open jobs that match selected candidates or uploaded resumes.',
  },
];

/** A candidate pre-loaded into the Job Match Report modal from a page selection. */
export interface ReportCandidate {
  userProfileId: number;
  name: string;
  /** Optional display data carried from the already-authorized selection surface. */
  subtitle?: string;
}

export const distanceItems = [
  { id: 10, title: '10 miles' },
  { id: 20, title: '20 miles' },
  { id: 30, title: '30 miles' },
  { id: 40, title: '40 miles' },
  { id: 50, title: '50 miles' },
  { id: 60, title: '60 miles' },
  { id: 70, title: '70 miles' },
  { id: 80, title: '80 miles' },
  { id: 90, title: '90 miles' },
  { id: 100, title: '100+ miles' },
];
